import reducer from './cashoutReducer';
import actions from './cashoutActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
